<template>
  <div class="airSystemWrap">
    <div class="top">
      <div class="top-left ashComWrap">
        <div class="comTitle">
          <h4>中央空调系统概览</h4>
        </div>
        <div class="comContentBox top-left-content" v-loading="loadingTLC">
          <HeadTips v-if="airCenterData?.length" :listData="airCenterData" />
          <el-empty
            v-else
            class="empty"
            :image-size="60"
            description="暂无数据"
          ></el-empty>
        </div>
      </div>
      <!-- <div class="top-right ashComWrap">
        <div class="comTitle">
          <h4>分体空调系统概览</h4>
        </div>
        <div class="comContentBox top-right-content" v-loading="loadingTRC">
          <template
            v-if="
              airSplitData?.leftNode?.length || airSplitData?.rightNode?.length
            "
          >
            <div>
              <HeadTips :listData="airSplitData.leftNode" />
            </div>
            <div>
              <HeadTips :listData="airSplitData.rightNode" twoLine />
            </div>
          </template>
          <el-empty
            v-else
            class="empty"
            :image-size="60"
            description="暂无数据"
          ></el-empty>
        </div>
      </div> -->
    </div>
    <div class="center ashComWrap">
      <div class="comTitle">
        <h4>中央空调主机系统</h4>
        <div>
          <span>更新时间:</span>
          <span style="margin-left: 5px">{{ updateTime }}</span>
          <el-button
            type="primary"
            round
            size="mini"
            style="margin: 0 10px"
            :loading="loadingCenterData"
            @click="getCenterPanelData(centerTabsId)"
            >刷新</el-button
          >
        </div>
      </div>
      <div
        class="comContentBox center-content"
        v-loading="loadingCC"
        element-loading-background="rgba(255, 255, 255, 0.95)"
      >
        <el-tabs
          v-if="centerTabs.length"
          v-model="centerTabsValue"
          type="card"
          @tab-click="changeCenter"
        >
          <el-tab-pane
            v-for="(item, index) in centerTabs"
            :key="`${item?.id}-${index}`"
            :label="item.name"
            :name="item.name"
            lazy
          >
            <CenterPanel
              :dataGather="centerPanelData"
              :assetId="item?.id"
              :energyType="item?.energyType"
            />
          </el-tab-pane>
        </el-tabs>
        <el-empty
          v-else
          class="empty"
          :image-size="250"
          description="暂无数据"
        ></el-empty>
      </div>
    </div>
    <div class="bottom">
      <div>
        <TableWithJump
          titleName="空调系统报警"
          :listData="alarmListData"
          :tableData="alarmTableData"
          :tableDataHead="alarmTableHead"
          jumpUrl="/alarmManagement"
        />
      </div>
      <div>
        <TableWithJump
          titleName="空调系统工单"
          :listData="workListData"
          :tableData="workTableData"
          :tableDataHead="workTableHead"
          jumpUrl="/worksheets"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TableWithJump from "@/components/TableWithJump/TableWithJump";
import HeadTips from "@/components/HeadTips/HeadTips";
import CenterPanel from "@/components/zixitong/airSystem/system/CenterPanel";
import api from "@/api";
import {
  dateFtt,
  matchingAlarmLevel,
  matchingOrderLevel,
  formatTime,
  getProjectVal,
  matchingAirAction,
  matchingStatus,
  dealNumWith,
  matchingFireStatus,
} from "@/assets/js/utils";
import {
  DEFAULTCOOLINGTOWERCONTENT,
  DEFAULTWATERTOOLSCONTENT,
} from "@/assets/js/const";

export default {
  components: { TableWithJump, HeadTips, CenterPanel },
  data() {
    return {
      //概览  主机系统实时功率
      airCenterData: [],
      airSplitData: {
        leftNode: [],
        rightNode: [],
      },
      //中部中央空调主机系统
      loadingCenterData: false,
      updateTime: dateFtt("yyyy-MM-dd hh:mm:ss", new Date()),
      centerTabsValue: "",
      centerTabsEnergyType: "cool",
      centerTabsId: null,
      centerTabs: [],
      centerPanelData: {
        //空调主机
        airHost: {
          title: [],
          contentSwitch: [],
        },
        //分水，集水
        waterTools: {
          content: DEFAULTWATERTOOLSCONTENT,
          contentSwitch: [],
        },
        //冷却塔
        coolingTower: {
          title: [],
          content: DEFAULTCOOLINGTOWERCONTENT,
          contentSwitch: [],
        },
        //冷冻水泵
        frozenWater: {
          title: [],
          contentSwitch: [],
        },
        //冷却水泵
        coolingWater: {
          title: [],
          contentSwitch: [],
        },
        //环境监测
        envMonitorData: [],
        //主机能效
        hostEnergyData: {
          topNode: [],
          bottomNode: [],
        },
        //锅炉机组
        obtainBoilerList: {
          title: [],
          contentSwitch: [],
        },
        //暖水泵
        warmWater: {
          title: [],
          contentSwitch: [],
        },
        //锅炉能效
        boilerEnergyData: {
          topNode: [],
          bottomNode: [],
        },
      },
      //报警
      alarmListData: [],
      alarmTableData: [],
      alarmTableHead: [
        { label: "ID", prop: "alarmId" },
        { label: "报警时间", prop: "time" },
        { label: "设备名称", prop: "deviceName" },
        { label: "设备/区域地址", prop: "location" },
        { label: "处理状态", prop: "confirm" },
        { label: "报警级别", prop: "level" },
      ],
      //工单
      workListData: [],
      workTableData: [],
      workTableHead: [
        { label: "工单ID", prop: "id" },
        { label: "工单名称", prop: "description" },
        { label: "工单级别", prop: "priority" },
        { label: "地点", prop: "location" },
        { label: "处理人", prop: "handlers" },
        { label: "处理时长", prop: "time" },
      ],
      loadingTLC: false,
      loadingTRC: false,
      loadingCC: false,
    };
  },
  methods: {
    async getAlarmsList() {
      let res = await api.lightingOSGetAlarms({
        projectId: getProjectVal("Id"),
        deviceType: "空调系统",
        pageSize: 5,
        page: 0,
      });
      if (res && res.data.code == 200) {
        this.alarmListData = Array.from(res.data.data.statistics).map(
          (item) => ({
            name: item.name == "total" ? "全部" : matchingAlarmLevel(item.name),
            value: item.value,
          })
        );
        this.alarmTableData = res.data.data.page.data;
        this.alarmTableData.map((v) => {
          v.time = v.endTime
            ? dateFtt("yyyy-MM-dd hh:mm:ss", new Date(v.endTime))
            : "";
          v.confirm = v.confirm ? "已确认" : "未确认";
          v.level = matchingAlarmLevel(v.level);
        });
      }
    },
    async getWorkOrderList() {
      let res = await api.lightingOSGetWorkOrder({
        projectId: getProjectVal("Id"),
        deviceType: "空调系统",
        pageSize: 5,
        page: 0,
      });
      if (res && res.data.code == 200) {
        this.workListData = Array.from(res.data.data.statistics).map(
          (item) => ({
            name: item.name == "total" ? "全部" : matchingOrderLevel(item.name),
            value: item.value,
          })
        );
        this.workTableData = res.data.data.page.data;
        this.workTableData.map((v) => {
          v.priority = matchingOrderLevel(v.priority);
          v.time = v.ts ? formatTime(v.ts) : "";
          v.handlers = v.assignStaffNames.join("、");
        });
      }
      // console.log(res);
    },
    dealNameWithAll(data = []) {
      const objAll = {
        nameTotal: "全部",
        valueTotal: 0,
        name: "末端开启",
        value: 0,
        rateFlag: true,
      };
      const newData = data.filter((item) => {
        if (item.name == "末端开启") {
          objAll.value = item.value;
          return false;
        } else if (item.name == "全部") {
          objAll.valueTotal = item.value;
          return false;
        }
        return true;
      });
      return {
        newData,
        objAll,
      };
    },
    //中央空调概览
    async getOverviewOfCentralAirConditioning() {
      this.loadingTLC = true;
      let res = await api.ACRGetOverviewOfCentralAirConditioning({
        projectId: getProjectVal("Id"),
      });
      if (res && res.data.code == 200) {
        const { objAll, newData } = this.dealNameWithAll(res.data.data);
        newData.push(objAll);
        this.airCenterData = newData;
      } else {
        console.log("获取中央空调概览失败");
      }
      this.loadingTLC = false;
    },
    //获取分体式空调概览
    // async getOverviewOfSplitAirConditioner() {
    //   this.loadingTRC = true;
    //   let res = await api.ACRGetOverviewOfSplitAirConditioner({
    //     projectId: getProjectVal("Id"),
    //     deviceType: "分体式空调",
    //   });
    //   if (res && res.data.code == 200) {
    //     const { objAll, newData } = this.dealNameWithAll(res.data.data);
    //     this.airSplitData = {
    //       leftNode: [objAll],
    //       rightNode: newData.map((item) => {
    //         item.name = matchingAirAction(item.name);
    //         return item;
    //       }),
    //     };
    //   } else {
    //     console.log("获取分体式空调概览失败");
    //   }
    //   this.loadingTRC = false;
    // },
    //获取中央空调列表
    async getCentralAirConditioning() {
      let res = await api.ACRGetCentralAirConditioning({
        projectId: getProjectVal("Id"),
        deviceType: "中央空调主机,锅炉,空气源热泵",
      });
      if (res && res.data.code == 200) {
        this.centerTabs = res.data.data.map((item, index) => {
          item.title = item.name;
          if (index === 0) {
            this.centerTabsValue = item.name;
            this.centerTabsId = item.id;
            this.centerTabsEnergyType = item.energyType;
            this.getCenterPanelData(item.id, item.energyType);
          }
          return item;
        });
      } else {
        console.log("获取中央空调列表失败");
      }
    },
    //获取中间模块数据
    async getCenterPanelData(assetId, energyType) {
      this.loadingCenterData = true;
      this.loadingCC = true;
      const q3 = this.getDiversionWaterCollectorList(assetId);
      const q5 = this.getEnvironmentalMonitoring(assetId);
      const queryType = energyType || this.centerTabsEnergyType;
      if (queryType === "cool") {
        //制冷
        const q1 = this.getCentralAirConditioningHostList(assetId);
        const q2 = this.getCoolingTowerList(assetId);
        const q4 = this.getWaterPumpCollect(assetId);
        const q6 = this.getHostEnergyEfficiency(assetId, "DAY");
        await Promise.all([q1, q2, q3, q4, q5, q6]).catch((err) => {
          console.log("---getCenterPanelData---err----", err);
        });
      } else {
        //电制热，燃气制热
        const q7 = this.getBoilerEnergyEfficiency(assetId, "DAY");
        const q8 = this.getWarmWaterPumpList(assetId);
        const q9 = this.getObtainBoilerList(assetId);
        await Promise.all([q3, q5, q7, q8, q9]).catch((err) => {
          console.log("---getCenterPanelData---err----", err);
        });
      }

      this.loadingCenterData = false;
      this.loadingCC = false;
      this.updateTime = dateFtt("yyyy-MM-dd hh:mm:ss", new Date());
    },
    dealCenterPanelData(
      data = {},
      hasTitle = false,
      hasContent = false,
      mainElementIsArray = false,
      contentSwitchType = "default",
      combineNameUnit = true
    ) {
      const { on = 0, off = 0, children = [], main = [] } = data;
      const dataObj = {
        contentSwitch: [],
      };
      if (hasTitle) {
        dataObj.title = [
          {
            name: "运行中",
            value: on,
            colorValue: "#28CCCB",
          },
          {
            name: "已关闭",
            value: off,
          },
        ];
      }
      if (contentSwitchType == "coolingTower") {
        Array.isArray(children) &&
          children.forEach((element) => {
            const childObj = {
              name: "主机",
              state: "",
              value: "",
              description: "",
            };
            Array.isArray(element) &&
              element.forEach((item) => {
                if (item.name == "name") {
                  childObj.name = item.value;
                } else if (item.name != "id") {
                  if (item.name === "状态") {
                    childObj.state = matchingStatus(item.value);
                  } else {
                    childObj.value = dealNumWith(item.value, 1, "-");
                    childObj.description = item.unit
                      ? `${item.name}(${item.unit})`
                      : item.name;
                  }
                }
              });
            dataObj.contentSwitch.push(childObj);
          });
      } else if (
        ["obtainBoiler", "waterPumpCollector"].includes(contentSwitchType)
      ) {
        Array.isArray(children) &&
          children.forEach((element) => {
            const childObj = {
              name: "主机",
              state: "",
              value: [],
            };
            Array.isArray(element) &&
              element.forEach((item) => {
                if (item.name == "name") {
                  childObj.name = item.value;
                } else if (item.name != "id") {
                  if (item.name === "状态") {
                    if (contentSwitchType == "waterPumpCollector") {
                      childObj.state = matchingStatus(item.value);
                    } else {
                      if (item.value == -1) {
                        childObj.state = "obtainBoiler"===contentSwitchType?"火力关闭":"已关闭";
                      } else {
                        childObj.state = "运行中";
                        item.value = matchingFireStatus(item.value);
                        item.name = "火力";
                        childObj.value.push(item);
                      }
                    }
                  } else {
                    item.value = dealNumWith(item.value, 1, "-");
                    if (item?.unit && combineNameUnit) {
                      item.name = `${item.name}(${item.unit})`;
                      item.unit = null;
                    }
                    childObj.value.push(item);
                  }
                }
              });
            dataObj.contentSwitch.push(childObj);
          });
      } else {
        Array.isArray(children) &&
          children.forEach((element) => {
            const childObj = {
              name: "主机",
              value: [],
            };
            Array.isArray(element) &&
              element.forEach((item) => {
                if (item.name == "name") {
                  childObj.name = item.value;
                } else if (item.name != "id") {
                  if (item.name === "状态") {
                    item.value = matchingStatus(item.value);
                    item.colorValue =
                      matchingStatus(item.value) == "运行中" ? "#28CCCB" : null;
                    item.fontSize = "14px";
                  } else {
                    item.value = dealNumWith(item.value, 1, "-");
                    if (item?.unit && combineNameUnit) {
                      item.name = `${item.name}(${item.unit})`;
                      item.unit = null;
                    }
                  }
                  childObj.value.push(item);
                }
              });
            dataObj.contentSwitch.push(childObj);
          });
      }
      if (hasContent) {
        if (mainElementIsArray) {
          Array.isArray(main) &&
            main.forEach((element) => {
              dataObj.content = [];
              Array.isArray(element) &&
                element.forEach((item) => {
                  if (item.name == "name") {
                    item.name = item.value;
                  } else if (item.name != "id") {
                    item.value =
                      item.name === "状态"
                        ? matchingStatus(item.value)
                        : dealNumWith(item.value, 1, "-");
                    dataObj.content.push(item);
                  }
                });
            });
        } else {
          dataObj.content = [];
          Array.isArray(main) &&
            main.forEach((item) => {
              if (item.name == "name") {
                item.name = item.value;
              } else if (item.name != "id") {
                item.value =
                  item.name === "状态"
                    ? matchingStatus(item.value)
                    : dealNumWith(item.value, 1, "-");
                dataObj.content.push(item);
              }
            });
        }
      }
      return dataObj;
    },
    //获取空调主机
    async getCentralAirConditioningHostList(assetId) {
      let res = await api.ACRGetCentralAirConditioningHostList({
        projectId: getProjectVal("Id"),
        deviceType: "中央空调主机",
        assetId: assetId || this.centerTabsId,
      });
      if (res && res.data.code == 200) {
        this.centerPanelData.airHost = this.dealCenterPanelData(
          res.data.data,
          true
        );
      } else {
        console.log("获取空调主机失败");
      }
    },
    //获取冷冻,冷却水泵
    getWaterPumpCollect(assetId) {
      //获取冷冻水泵
      this.getWaterPumpCollectorList(assetId, "冷冻水泵", "frozenWater");
      //获取冷却水泵
      this.getWaterPumpCollectorList(assetId, "冷却水泵", "coolingWater");
    },
    async getWaterPumpCollectorList(assetId, deviceType, dataType) {
      let res = await api.ACRGetWaterPumpCollectorList({
        projectId: getProjectVal("Id"),
        deviceType,
        assetId: assetId || this.centerTabsId,
      });
      if (res && res.data.code == 200) {
        this.centerPanelData[dataType] = this.dealCenterPanelData(
          res.data.data,
          true,
          false,
          false,
          "waterPumpCollector"
        );
      } else {
        console.log("获取冷冻,冷却水泵失败");
      }
    },
    //获取暖水泵
    async getWarmWaterPumpList(assetId) {
      let res = await api.ACRGetWarmWaterPumpList({
        projectId: getProjectVal("Id"),
        deviceType: "暖水泵",
        assetId: assetId || this.centerTabsId,
      });
      if (res && res.data.code == 200) {
        this.centerPanelData.warmWater = this.dealCenterPanelData(
          res.data.data,
          true,
          false,
          false,
          "waterPumpCollector"
        );
      } else {
        console.log("获取暖水泵失败");
      }
    },
    //获取冷却塔列表
    async getCoolingTowerList(assetId) {
      let res = await api.ACRGetCoolingTowerList({
        projectId: getProjectVal("Id"),
        deviceType: "冷却塔",
        assetId: assetId || this.centerTabsId,
      });
      if (res && res.data.code == 200) {
        const newData = this.dealCenterPanelData(
          res.data.data,
          true,
          true,
          false,
          "coolingTower"
        );
        if (newData?.content?.length === 0) {
          newData.content = DEFAULTCOOLINGTOWERCONTENT;
        }
        this.centerPanelData.coolingTower = newData;
      } else {
        console.log("获取冷却塔列表失败");
      }
    },
    //获取锅炉机组
    async getObtainBoilerList(assetId) {
      let res = await api.ACRGetObtainBoilerList({
        projectId: getProjectVal("Id"),
        deviceType: "锅炉",
        assetId: assetId || this.centerTabsId,
        energyType: this.centerTabsEnergyType,
      });
      if (res && res.data.code == 200) {
        const newData = this.dealCenterPanelData(
          res.data.data,
          true,
          false,
          false,
          "obtainBoiler"
        );
        this.centerPanelData.obtainBoilerList = newData;
      } else {
        console.log("获取锅炉机组失败");
      }
    },
    //获取分水器、集水器列表
    async getDiversionWaterCollectorList(assetId) {
      let res = await api.ACRGetDiversionWaterCollectorList({
        projectId: getProjectVal("Id"),
        assetId: assetId || this.centerTabsId,
        highDeviceType: "分集水器",
        lowDeviceType: "分集水管",
      });
      if (res && res.data.code == 200) {
        const newData = this.dealCenterPanelData(
          res.data.data,
          false,
          true,
          true,
          false,
          false
        );
        if (newData?.content?.length === 0) {
          newData.content = DEFAULTWATERTOOLSCONTENT;
        }
        this.centerPanelData.waterTools = newData;
      } else {
        console.log("获取分水器、集水器列表失败");
      }
    },
    //环境监测
    async getEnvironmentalMonitoring(assetId) {
      let res = await api.ACRGetEnvironmentalMonitoring({
        projectId: getProjectVal("Id"),
        assetId: assetId || this.centerTabsId,
        modular: "环境监测",
      });
      if (res && res.data.code == 200) {
        const { newData } = this.dealNameWithAll(res.data.data);
        this.centerPanelData.envMonitorData = newData;
      } else {
        console.log("获取中央空调概览失败");
      }
    },
    //主机能效
    async getHostEnergyEfficiency(assetId, dateType) {
      let res = await api.ACRGetHostEnergyEfficiency({
        projectId: getProjectVal("Id"),
        assetId: assetId || this.centerTabsId,
        deviceType: "中央空调主机",
        dateType,
      });
      if (res && res.data.code == 200) {
        const topNode = [];
        const bottomNode = res.data.data.filter((item) => {
          if (item.name == "总制冷量" || item.name == "主机系统总能耗") {
            topNode.push(item);
            return false;
          }
          return true;
        });
        this.centerPanelData.hostEnergyData = {
          topNode,
          bottomNode,
        };
      } else {
        console.log("获取主机能效失败");
      }
    },
    //锅炉能效
    async getBoilerEnergyEfficiency(assetId, dateType) {
      let res = await api.ACRGetBoilerEnergyEfficiency({
        // projectId: getProjectVal('Id'),
        assetId: assetId || this.centerTabsId,
        deviceType: "锅炉",
        dateType,
      });
      if (res && res.data.code == 200) {
        const topNode = [];
        const bottomNode = res.data.data.filter((item) => {
          if (item.name == "总制热量" || item.name == "主机系统总能耗") {
            topNode.push(item);
            return false;
          }
          return true;
        });
        this.centerPanelData.boilerEnergyData = {
          topNode,
          bottomNode,
        };
      } else {
        console.log("获取锅炉能效失败");
      }
    },
    changeCenter(tab) {
      const newId = this.centerTabs[tab.index].id;
      const newEnergyType = this.centerTabs[tab.index].energyType;
      this.centerTabsId = newId;
      this.centerTabsEnergyType = newEnergyType;
      this.getCenterPanelData(newId, newEnergyType);
    },
  },
  created() {
    this.getAlarmsList();
    this.getWorkOrderList();
    this.getOverviewOfCentralAirConditioning();
    // this.getOverviewOfSplitAirConditioner();
    this.getCentralAirConditioning();
  },
  mounted() {
    this.$bus.$on("getHostEnergyEfficiency", (assetId, dateType) => {
      this.getHostEnergyEfficiency(assetId, dateType);
    });
    this.$bus.$on("getBoilerEnergyEfficiency", (assetId, dateType) => {
      this.getBoilerEnergyEfficiency(assetId, dateType);
    });
  },
  beforeDestroy() {
    this.$bus.$off("getHostEnergyEfficiency");
    this.$bus.$off("getBoilerEnergyEfficiency");
  },
};
</script>

<style lang="scss" scoped>
$borderRadius: 5px;

.airSystemWrap {
  width: 100%;
  overflow: auto;
  padding: 16px 0;
  min-width: 1600px;

  .top {
    // width: 96%;
    // margin: 0 auto;
    width: calc(100% - 32px);
    margin: 0 16px;
    height: 200px;
    @include setFlexBetween;

    &-left {
      flex-grow: 1;

      &-content {
        width: calc(100% - 15px);
        padding-left: 15px;
      }
    }

    &-right {
      margin-left: 8px;
      width: 400px;
      flex-grow: 0;

      &-content {
        padding-right: 15px;
        @include setFlexBetween;

        & > div {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .center {
    height: 990px;
    // margin: 20px auto;
    // width: 96%;
    width: calc(100% - 32px);
    margin: 12px 16px;
  }

  .bottom {
    width: calc(100% - 32px);
    margin: 0 16px;
    // width: 96%;
    // margin: 0 auto;
    height: 500px;
    @include setFlexBetween;

    & > div {
      width: 49.5%;
      height: 100%;
    }
  }
}
</style>
